import { useEffect, useState } from 'react'
import styled from 'styled-components'
import { useIntl } from '../utils/IntlContext'
import { createAppUrl } from '../utils/locales'
import media from '../utils/media'
import CTA from './CTA'

const SampleButton = styled(CTA)`
  position: fixed;
  bottom: ${({ $showStickyButton }) => ($showStickyButton ? 0 : -57)}px;
  left: 0;
  right: 0;
  z-index: 10;
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.71;
  border-radius: 0;
  padding: 16px;
  transition: all 0.5s;

  ${media.md`
    display: none;
  `}
`

const StickySampleButton = ({ highlightedResume, signupLink }) => {
  const [showStickyButton, setShowStickyButton] = useState(false)
  const { locale, t } = useIntl()
  const toggleSampleButton = () => {
    if (window.innerHeight < window.scrollY) {
      setShowStickyButton(true)
    } else {
      setShowStickyButton(false)
    }
  }

  useEffect(() => {
    if (typeof window === 'undefined') {
      return
    }

    window.addEventListener('scroll', toggleSampleButton)

    const removeScrollListener = () => {
      window.removeEventListener('scroll', toggleSampleButton)
    }

    return removeScrollListener
  }, [])

  return highlightedResume.sample ? (
    <SampleButton
      $showStickyButton={showStickyButton}
      $primary
      to={createAppUrl(`/?sample=${highlightedResume.slug}`, locale)}
      rel="nofollow">
      {t('use_this_sample')}
    </SampleButton>
  ) : (
    <SampleButton
      $showStickyButton={showStickyButton}
      $primary
      to={signupLink}>
      {t('signup')}
    </SampleButton>
  )
}

export default StickySampleButton
